/**
 * Escape a value for interpolation into report/print HTML.
 *
 * The report exporters build HTML by string interpolation, and much of what
 * they interpolate is merchant- or customer-entered: product names, SKUs,
 * categories, customer names, GSTINs, invoice numbers. Unescaped, a stray `<`
 * corrupts the table, and markup can pull remote resources when the page
 * renders.
 *
 * The print frame is sandboxed without `allow-scripts` (see platform/index.ts),
 * so injected script cannot execute — this is the second layer, and the one
 * that keeps reports *correct* rather than merely safe.
 *
 * Coerces rather than assuming a string: these fields come from WatermelonDB
 * and can be null for older rows.
 */
export function escapeHtml(value: unknown): string {
  return String(value ?? '').replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string,
  );
}
